<template>
	<div>
		<ModalCari ref="modalCari" :filterChart="filterChart" @filterResume="filterResume"></ModalCari>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Dashboard</div>
		</div>
		<div class="mt-5" v-if="loading">
			<div v-for="i in 2" :key="i">
				<v-card height="15" width="240" elevation="0" class="mb-2">
					<vcl :height='15' :width='240'>
						<rect x="0" y="0" rx="2" ry="2" width="240" height="15" />
					</vcl>
				</v-card>
				<div class="row ml-0">
					<v-col cols="2" class="pl-0" v-for="i in 6" :key="i">
						<v-card height="85" width="180">
							<vcl :height='85' :width='180'>
								<rect x="15" y="15" rx="8" ry="8" width="25" height="25" />
								<rect x="140" y="15" rx="8" ry="8" width="25" height="25" />
								<rect x="70" y="60" rx="4" ry="4" width="95" height="20" />
							</vcl>
						</v-card>
					</v-col>
				</div>
				<div class="row ml-0">
					<div class="col-6 pl-0" v-for="i in 2" :key="i">
						<v-card height="260" width="550">
							<vcl :height='260' :width='550'>
								<rect x="15" y="15" rx="4" ry="4" width="120" height="15" />
								<rect x="15" y="50" rx="4" ry="4" width="450" height="190" />
							</vcl>
						</v-card>
					</div>
				</div>
			</div>
		</div>
		<div v-if="!loading">
			<div class="mt-5">
				<v-btn text small color="grey darken-3" class="">
					<div class="pr-2">Resume Aktivitas Penjualan</div>
					<v-icon>mdi-chevron-right</v-icon>
				</v-btn>
			</div>
			<v-card color="white" class="my-2" height="100" width="350" v-if="listStatusSales.length == 0">
				<not-found></not-found>
			</v-card>
			<div v-if="renderChart">
				<div v-if="listStatusSales.length > 0">
					<carousel :loop="false" :responsive="{0:{items:2},600:{items:4},1000:{items:6},1500:{items:8}}" :nav="false" :dots="false" :margin="5">
						<div v-for="(statusSales, i) in listStatusSales" :key="i" class="pt-2 pb-3 px-1">
							<v-card class="text-body-2" height="85" width="180">
								<v-col cols="12" class="pt-3 pb-1 d-flex justify-space-between mt-2">
									<div>
										<v-icon color="deep-purple lighten-3" v-if="statusSales.so_status == 'created'">mdi-sticker-check</v-icon>
										<v-icon color="deep-purple lighten-3" v-else-if="statusSales.so_status == 'approved'">mdi-circle-slice-6</v-icon>
										<v-icon color="deep-purple lighten-3" v-else-if="statusSales.so_status == 'paid'">mdi-database-check</v-icon>
										<v-icon color="deep-purple lighten-3" v-else-if="statusSales.so_status == 'processed'">mdi-arrow-up-bold-circle</v-icon>
										<v-icon color="deep-purple lighten-3" v-else-if="statusSales.so_status == 'completed'">mdi-check-circle</v-icon>
										<v-icon color="pink lighten-3" v-else>mdi-close-circle</v-icon>
									</div>
									<div class="text-right my-auto grey--text text--darken-3">
										<div class="text-h5">{{ statusSales.count_status | toNumber }}</div>
									</div>
								</v-col>
								<div class="px-3 text-right">
									<div class="text-body-2">{{ statusSales.so_status | toSalesActivity }}</div>
								</div>
							</v-card>
						</div>
					</carousel>
				</div>
			</div>
			<div>
				<v-row class="mr-0" v-if="renderChart">
					<v-col cols="12" md="6" class="pr-0">
						<v-card class="pt-2">
							<div class="px-4">
								<div class="text-overline grey--text text--darken-3 text-uppercase">Resume Penjualan</div>
							</div>
							<sschart />
						</v-card>
					</v-col>
					<v-col cols="12" md="6" class="pr-0">
						<v-card class="pt-2">
							<div class="px-4">
								<div class="text-overline grey--text text--darken-3 text-uppercase">Resume Pembelian</div>
							</div>
							<pschart />
						</v-card>
					</v-col>
				</v-row>
			</div>
			<div>
				<div class="mt-3">
					<v-btn text small color="grey darken-3" class="">
						<div class="pr-2">Resume Stok Produk</div>
						<v-icon>mdi-chevron-right</v-icon>
					</v-btn>
				</div>
				<v-card color="white" class="my-2" height="100" width="350" v-if="listResumeStock.length == 0">
					<not-found></not-found>
				</v-card>
				<div v-if="renderChart">
					<div v-if="listResumeStock.length > 0">
						<carousel :loop="false" :responsive="{0:{items:2},600:{items:4},1000:{items:6},1500:{items:8}}" :nav="false" :dots="false" :margin="5">
							<div v-for="(resumeStock, i) in listResumeStock" :key="i" class="pt-2 pb-3 px-1">
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-card class="text-body-2" height="85" width="180" :color="resumeStock.product_stock_value | toColorProduct" v-bind="attrs" v-on="on">
											<v-col cols="12" class="pt-3 pb-1 d-flex justify-space-between mt-2">
												<div class="my-auto grey--text text--darken-3">
													<div class="text-body-2">{{ resumeStock.product_code }}</div>
													<div class="text-h4">{{ resumeStock.product_stock_value | toNumber }}<span class="pl-2 text-body-2 grey--text text--darken-3 text-capitalize">{{ resumeStock.product_unit }}</span></div>
												</div>
											</v-col>
										</v-card>
									</template>
									<span>{{ resumeStock.product_name }}</span>
								</v-tooltip>
							</div>
						</carousel>
					</div>
				</div>
			</div>
			<div>
				<v-row class="mr-0" v-if="renderChart">
					<v-col cols="12" md="12" class="pr-0">
						<v-card class="pt-2">
							<div class="px-4 d-flex justify-space-between">
								<div class="text-overline grey--text text--darken-3 text-uppercase">Resume Produk Terjual</div>
								<!-- <v-icon>mdi-dots-vertical</v-icon> -->
							</div>
							<!-- <v-menu transition="scroll-y-transition">
								<template v-slot:activator="{ on, attrs }">
									<v-btn text small color="grey darken-1" dark class="mx-1 mt-2 mb-3" v-bind="attrs" v-on="on">
										<div class="text-capitalize">Supplier</div>
										<v-icon>mdi-menu-down</v-icon>
									</v-btn>
								</template>
								<v-list>
									<v-list-item link>
										<v-list-item-title class="text-body-2 grey--text text--darken-3">Supplier</v-list-item-title>
									</v-list-item>
									<v-list-item link>
										<v-list-item-title class="text-body-2 grey--text text--darken-3">Warehouse</v-list-item-title>
									</v-list-item>
								</v-list>
							</v-menu>
							<v-menu transition="scroll-y-transition">
								<template v-slot:activator="{ on, attrs }">
									<v-btn text small color="grey darken-1" dark class="mx-1 mt-2 mb-3" v-bind="attrs" v-on="on">
										<div class="text-capitalize">1 Bulanan</div>
										<v-icon>mdi-menu-down</v-icon>
									</v-btn>
								</template>
								<v-list>
									<v-list-item link>
										<v-list-item-title class="text-body-2 grey--text text--darken-3">3 Bulanan</v-list-item-title>
									</v-list-item>
									<v-list-item link>
										<v-list-item-title class="text-body-2 grey--text text--darken-3">6 Bulanan</v-list-item-title>
									</v-list-item>
								</v-list>
							</v-menu> -->
							<salesChart />
						</v-card>
					</v-col>
					<v-col cols="12" md="4" class="pr-0" v-if="false">
						<v-card class="pt-2">
							<div class="px-4 d-flex justify-space-between">
								<div class="text-overline grey--text text--darken-3 text-uppercase">Resume Top 5 Produk</div>
							</div>
							<div class="pb-2" v-if="listTopProduct.length == 0">
								<not-found></not-found>
							</div>
							<div v-else>
								<v-list-item class="border-bottom border-grey py-1" v-for="topProduct in listTopProduct" :key="topProduct.so_detail_product_id">
									<v-chip class="white--text font-weight-bold" color="deep-purple accent-3">{{ topProduct.rank }}</v-chip>
									<v-list-item-avatar color="primary" class="ml-4">
										<v-img class="elevation-6" src="/assets/produk/produk-milagros-water-ro-big.png"></v-img>
									</v-list-item-avatar>
									<v-list-item-content class="ml-4">
										<v-list-item-title class="grey--text text--darken-3">{{ topProduct.so_detail_product_name }}</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</div>
						</v-card>
					</v-col>
					<v-col cols="12" md="12" class="pr-0">
						<v-card class="pt-2">
							<div class="px-4 d-flex justify-space-between flex-wrap">
								<div class="text-overline grey--text text--darken-3 text-uppercase">Resume Produk Terjual Harian</div>
								<div class="pt-2">
									<v-btn depressed color="primary" width="100" @click="showCari('so-product')">
										<div class="text-body-2 text-capitalize">Filter</div>
									</v-btn>
								</div>
							</div>
							<salesProductChart fitur="sales-order"/>
						</v-card>
					</v-col>
					<v-col cols="12" md="12" class="pr-0">
						<v-card class="pt-2">
							<div class="px-4 d-flex justify-space-between flex-wrap">
								<div class="text-overline grey--text text--darken-3 text-uppercase">Resume Penjualan</div>
								<div class="pt-2">
									<v-btn depressed color="primary" width="100" @click="showCari('so-price')">
										<div class="text-body-2 text-capitalize">Filter</div>
									</v-btn>
								</div>
							</div>
							<salesPriceChart fitur="sales-order"/>
						</v-card>
					</v-col>
					<v-col cols="12" md="12" class="pr-0">
						<v-card class="pt-2">
							<div class="px-4 d-flex justify-space-between flex-wrap">
								<div class="text-overline grey--text text--darken-3 text-uppercase">Resume Produk Terjual Retail</div>
								<div class="pt-2">
									<v-btn depressed color="primary" width="100" @click="showCari('sr-product')">
										<div class="text-body-2 text-capitalize">Filter</div>
									</v-btn>
								</div>
							</div>
							<salesProductChart fitur="sales-retail"/>
						</v-card>
					</v-col>
					<v-col cols="12" md="12" class="pr-0">
						<v-card class="pt-2">
							<div class="px-4 d-flex justify-space-between flex-wrap">
								<div class="text-overline grey--text text--darken-3 text-uppercase">Resume Penjualan Retail</div>
								<div class="pt-2">
									<v-btn depressed color="primary" width="100" @click="showCari('sr-price')">
										<div class="text-body-2 text-capitalize">Filter</div>
									</v-btn>
								</div>
							</div>
							<salesPriceChart fitur="sales-retail"/>
						</v-card>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import sschart from './salesSummaryChart'
import pschart from './purchaseSummaryChart'
import salesChart from './productSummaryChart'
import salesProductChart from './salesProductChart'
import salesPriceChart from './salesPriceChart'
import ModalCari from './components/ModalCari';
import carousel from 'vue-owl-carousel'
import { mapActions,  mapState } from 'vuex'
import moment from 'moment';

export default {
	inject: ['theme'],
	components: {
		sschart, pschart, salesChart, carousel, salesProductChart, salesPriceChart, ModalCari
	},
	data() {
		return {
			model: null,
			renderChart: false,
			loading: true,
			menu: false,
			chartType: '',
			filterChart: {
				wh_id: null,
				filterDate: [],
				product_id: [],
			},
			filterChartProductSO: {
				wh_id: null,
				filterDate: [],
				product_id: [],
			},
			filterChartPriceSO: {
				wh_id: null,
				filterDate: [],
				product_id: [],
			},
			filterChartProductRetail: {
				wh_id: null,
				filterDate: [],
				product_id: [],
			},
			filterChartPriceRetail: {
				wh_id: null,
				filterDate: [],
				product_id: [],
			},
		}
	},
	computed: {
		...mapState('dashboard', ['listStatusSales', 'listResumeStock', 'listTopProduct', 'listWarehouse', 'listProduct', 'optionWarehouse']),

		maxDate() {
			if (this.filterDate.length == 0) {
				return this.today
			} else {
				var date = new Date();
				date.setDate(new Date(this.filterDate[0]).getDate() - 7);

				return this.today
			}
		},
		minDate() {
			var date = new Date();
			date.setDate(date.getDate() - 6);

			if (this.filterDate.length == 0) {
				return moment(date).format('YYYY-MM-DD')
			} else {
				return moment(date).format('YYYY-MM-DD')
			}
		}
	},
	methods: {
		...mapActions('dashboard', ['getStatusSales', 'getResumeStock', 'getTopProduct', 'getOptionWarehouseAll', 'getOptionProductMain', 'getSalesProductWeekly', 'getSalesPriceWeekly', 'getSalesRetailWeekly', 'getSalesRetailPriceWeekly']),

		getData() {
			this.getStatusSales().then(() => {
				this.getResumeStock().then(() => {
					this.getTopProduct().then(() => {
						this.getTopProduct().then(() => {
							this.loading = false
						})
					})
				})
			})
			setTimeout(() => {this.renderChart = true}, 500);
		},
		filterResume(data) {
			let date = ''
			if (data.filterDate) {
				data.filterDate.sort()
				date = data.filterDate.join('::')
			}
			if (this.chartType == 'so-product')
				this.getSalesProductWeekly({
					product: data.product_id,
					date: date,
					warehouse_id: data.wh_id
				})
			else if (this.chartType == 'so-price')
				this.getSalesPriceWeekly({
					product: data.product_id,
					date: date,
					warehouse_id: data.wh_id
				})
			else if (this.chartType == 'sr-product')
				this.getSalesRetailWeekly({
					product: data.product_id,
					date: date,
					warehouse_id: data.wh_id
				})
			else if (this.chartType == 'sr-price')
				this.getSalesRetailPriceWeekly({
					product: data.product_id,
					date: date,
					warehouse_id: data.wh_id
				})
		},
		showCari(type) {
			this.chartType = type
			if (type == 'so-product')
				this.filterChart = this.filterChartProductSO
			else if (type == 'so-price')
				this.filterChart = this.filterChartPriceSO
			else if (type == 'sr-product')
				this.filterChart = this.filterChartProductRetail
			else if (type == 'sr-price')
				this.filterChart = this.filterChartPriceRetail
			this.$refs.modalCari.modalShow()
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Dashboard`)
		this.getData()
		this.getOptionWarehouseAll()
		this.getOptionProductMain().then((res) => {
			this.filterChart.product_id = res.map((el) => el.product_id)
		})
	}
};
</script>